import { API } from "@/lib/api";
import { gaEvent } from "@/lib/ga";

export function track(name, meta = {}) {
  if (typeof window !== "undefined" && window.__PRERENDER__) return;
  try {
    gaEvent(name, meta);
    if (name === "cta_click") gaEvent("key_cta_click", meta);
    fetch(`${API}/events`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ name, path: window.location.pathname, meta }),
      keepalive: true,
    }).catch(() => {});
  } catch (e) {}
}
